var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "user-tools user-tools_row-wrap"
  }, [_c('div', {
    staticClass: "user-tools__el user-tools__el_compare"
  }, [_c('ActionCompare', {
    attrs: {
      "id": _vm.product.id,
      "product": _vm.product,
      "modal": {
        image: _vm.product.image,
        link: _vm.product.path,
        name: _vm.product.name
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var add = _ref.add,
            remove = _ref.remove,
            active = _ref.active,
            loading = _ref.loading;
        return [_c('CompareInlineTool', {
          attrs: {
            "active": active,
            "loading": loading
          },
          on: {
            "add": add,
            "remove": remove
          }
        })];
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "user-tools__el user-tools__el_favorite"
  }, [_c('ActionFavorite', {
    attrs: {
      "id": _vm.product.id,
      "product": _vm.product,
      "list-name": "Карточка товара"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var add = _ref2.add,
            remove = _ref2.remove,
            active = _ref2.active,
            loading = _ref2.loading;
        return [_c('FavoriteInlineTool', {
          attrs: {
            "active": active,
            "loading": loading
          },
          on: {
            "add": add,
            "remove": remove
          }
        })];
      }
    }])
  })], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }